import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'
export class KvSlider {
  constructor() {
    this.kvEl = document.querySelector('.p-index_kv')
    this.slidersEl = [...document.getElementsByClassName('js-kv-slider')]
    if (this.slidersEl.length === 0) return
    this.startThemeToggle()
    this.sliders = this.slidersEl.map((sliderEl, sliderIndex) => {
      sliderEl.classList.add('keen-slider')
      const slides = [...sliderEl.children]
      slides.forEach((slide) => {
        slide.classList.add('keen-slider__slide')
      })

      const speed = Number(sliderEl.dataset.speed)
      const duration = Number.isFinite(speed) && speed > 0 ? speed : 20000
      let animation = { duration, easing: (t) => t }
      const initialOffset = sliderIndex * 3

      const item = { sliderEl, slides }
      this.fillSlides(item)

      item.slider = new KeenSlider(sliderEl, {
        slides: {
          perView: 'auto',
        },
        mode: 'free-snap',
        loop: true,
        drag: false,
        created(s) {
          s.moveToIdx(-5 - initialOffset, true, animation)
        },
        updated(s) {
          s.moveToIdx(s.track.details.abs - 5, true, animation)
        },
        animationEnded(s) {
          s.moveToIdx(s.track.details.abs - 5, true, animation)
        },
      })
      return item
    })
    this.watchResize()
  }

  // ループの折り返しはスライダーの表示領域の端でしか行われないため、
  // スライド全体の幅が「表示領域 + スライド1枚」を超えるまで複製して隙間を作らせない
  fillSlides(item) {
    const { sliderEl, slides } = item
    const slideSize = slides[0].offsetWidth
    if (!slideSize) return false
    const setSize = slideSize * slides.length
    const needSize = sliderEl.offsetWidth + slideSize * 2
    const needSets = Math.max(1, Math.ceil(needSize / setSize))
    const currentSets = sliderEl.children.length / slides.length
    if (needSets <= currentSets) return false
    for (let i = currentSets; i < needSets; i++) {
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true)
        clone.setAttribute('aria-hidden', 'true')
        sliderEl.appendChild(clone)
      })
    }
    return true
  }

  // 画面が広くなった場合も隙間ができないよう、必要な枚数を再計算する
  watchResize() {
    let timer = null
    window.addEventListener('resize', () => {
      window.clearTimeout(timer)
      timer = window.setTimeout(() => {
        this.sliders.forEach((item) => {
          if (this.fillSlides(item)) item.slider.update()
        })
      }, 200)
    })
  }

  startThemeToggle() {
    if (!this.kvEl) return
    const interval = 5000
    window.setInterval(() => {
      this.kvEl.classList.toggle('is-orange')
    }, interval)
  }
}
